import {faLock} from "@fortawesome/free-solid-svg-icons";

export const colorDecodeStatus = (status) =>{
  switch (status) {
    case 'DEACTIVATED':
      return 'green';
    case 'ACTIVATED':
      return 'red';
    case 'ACTIVATION_IN_PROGRESS':
      return 'orange';
    case 'ACTIVATION_SUBMITED':
      return 'orange';
    case 'DEACTIVATION_IN_PROGRESS':
      return 'orange';
    case 'PLANNED':
      return 'blue';
    default:
      return 'green';

  }
}

export const progressIndex = (item) => {
    if (item.status === 'ACTIVATION_IN_PROGRESS') {
        return `${item.removed + item.trusted}/${item.processedKeys}`;
    } else {
        return `${item.processedKeys-item.removed- item.trusted}/${item.processedKeys}`;
    }
}

export const translateStatus = (status) => {
    switch (status) {
        case 'DEACTIVATED':
            return 'Désactivé';
        case 'ACTIVATED':
            return 'Activé';
        case 'ACTIVATION_IN_PROGRESS':
            return 'Activation en cours';
        case 'ACTIVATION_SUBMITED':
            return 'Activation en attente';
        case 'DEACTIVATION_IN_PROGRESS':
            return 'Désactivation en cours';
        case 'PLANNED':
            return 'Planifier';
        case undefined:
            return 'Désactivé';
        case 'PLAN_CANCELLED':
            return 'Planification annulée';
        default:
            return status;
    }
}

export const cardLabelForStatus = (item) => {
    switch (item.status) {
        case 'DEACTIVATED','ACTIVATED':
            return 'Statut: ' + translateStatus(item.status);
        case undefined:
            return 'Statut: ' + translateStatus(item.status);
        case 'PLANNED':
            return translateStatus(item.status);
        default:
            return translateStatus(item.status);
    }
}

export const iconForStatus = (status) =>{
    switch (status) {
        case undefined:
            return 'faUnlock';
        case 'ACTIVATED':
            return 'faLock';
        default:
            return null;
    }

}

export const formatDateSimple = (dateString) => {
    if (!dateString) return "-";
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    return `${day}/${month}/${year} ${hours}:${minutes}`;
}